module.exports = __webpack_public_path__ + "static/media/teamsGreenTick.a1bf2d2d.svg";